import React, { useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function SuppliersPayment() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",

    },
    {
      header: "Date",
      accessorKey: "Date",
    },
    {
      header: "Supplier",
      accessorKey: "Supplier",
    },
    {
      header: "Amount",
      accessorKey: "Amount",
    },
    {
      header: "Note",
      accessorKey: "Note",
    },
    {
      header: "DOB",
      accessorKey: "DOB",
    },
    {
      header: "Added By",
      accessorKey: "AddedBy",
    },
    {
      header: "Actions",
      accessorKey: "total",
      cell: (row) => <Dropdown />,
    },

  ]);
  const [data] = useState([


  ]);
  const [buttonData] = useState([
    {
      buttonText: "Add Supplier Due Payment",
      path: "addSupplierPaymentForm"
    },

  ]);

  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={"Supplier Due Payments"}
        buttonData={buttonData}


      />
    </main>
  );
}

export default SuppliersPayment;
